/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description To return the value of an array if it has only one element in it else return null.
 * @param array The array which needs to be checked
 */

export const getSingleItemValue = (array) => {
  if (!array || array.length !== 1) return null;
  return array[0];
};
